import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useMemo, useRef, useState, useCallback } from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ModalType } from '../../../../Modals/redux/types';
import { BiData } from '@wix/da-bi/pkg/events';
import ListMenu from '../../../../Dropdown/Preset/ListMenu';
import { mobileSubmitMenuItems } from '../../../constants';
import SubmitMenuItem from './SubmitMenuItem';
import { useOnOutsideClick } from '@wix/da-hooks/dist/src/useOnOutsideClick';
import s from './SubmitDropdown.scss';
const SubmitDropdown = ({ className , menuClassName , isLegacyHeader , hasCoreMembership  })=>{
    const eclipse_submit = useFlag('eclipse_submit');
    const rootRef = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const closeMenu = useCallback(()=>setOpen(false), []);
    useOnOutsideClick(rootRef, closeMenu);
    const mobileSubmitMenuItemsFiltered = mobileSubmitMenuItems.map((item)=>{
        // If user is non-core use new deviation submit flow. Also, if `eclipse_submit` is on.
        if (item.type === 'deviation' && (!hasCoreMembership || eclipse_submit)) {
            return _object_spread_props(_object_spread({}, item), {
                link: undefined,
                modalType: ModalType.DEVIATION_SUBMIT
            });
        }
        return item;
    });
    const submitMenuItems = useMemo(()=>{
        return mobileSubmitMenuItemsFiltered.map(({ type , label , target , verificationAction ='submit' , link , modalType , modalOptions  })=>{
            return {
                key: label,
                renderElement: ()=>/*#__PURE__*/ React.createElement(SubmitMenuItem, {
                        className: s['submit-menu-item'],
                        type: type,
                        modalType: modalType,
                        modalOptions: modalOptions,
                        label: label,
                        link: link,
                        target: target,
                        verificationAction: verificationAction,
                        isLegacyHeader: isLegacyHeader
                    })
            };
        });
    }, [
        isLegacyHeader,
        mobileSubmitMenuItemsFiltered
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement(BrandedButton, {
        variant: "brand-green",
        size: "medium",
        className: s['button'],
        onClick: ()=>setOpen((open)=>!open),
        biData: isOpen ? undefined : BiData({
            evid: 703,
            sectionname: 'dropdown'
        })
    }, /*#__PURE__*/ React.createElement(AddIcon, {
        className: s['icon'],
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    })), isOpen && /*#__PURE__*/ React.createElement(ListMenu, {
        className: c(s['menu'], menuClassName),
        items: submitMenuItems
    }));
};
SubmitDropdown.displayName = 'SubmitDropdown';
export default SubmitDropdown;
